module.exports = __webpack_public_path__ + "img/Logo-25.9e90cdfb.svg";